import { Flash, Box, colors, unit } from '@acast/decibel';
import T from 'prop-types';
import React from 'react';
import { mergeShowChanges } from 'routes/show/util';
import styled from 'styled-components';
import { getRequiredActions } from 'validation/show';

const Container = styled.div`
  background-color: ${colors.white};
  margin-bottom: ${unit(6)};
`;

const ListItem = styled.li`
  list-style: disc;
  list-style-position: inside;

  & + & {
    margin-top: 4px;
  }
`;

const ValidationErrors = ({ changes, show }) => {
  const showWithChanges = mergeShowChanges(show, changes);
  const actions = getRequiredActions(showWithChanges);

  if (!show || !actions.length) {
    return null;
  }

  return (
    <Container>
      <Flash intent="danger">
        Please note that you need to complete the following tasks before you can create or publish
        an episode:
        <Box as="ul" flexDirection="column" mt={2}>
          {actions.map((action, index) => {
            return <ListItem key={index}>{action}</ListItem>;
          })}
        </Box>
      </Flash>
    </Container>
  );
};

ValidationErrors.propTypes = {
  changes: T.object,
  show: T.object,
};

export default ValidationErrors;
